import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _class, _UserMenuItem_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './menu-item.hbs'; */
import Component from "@glimmer/component";
import { action } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { emojiUnescape } from "discourse/lib/text";
import { escapeExpression } from "discourse/lib/utilities";
import TEMPLATE from "./menu-item.hbs";
import { setComponentTemplate } from "@ember/component";
let UserMenuItem = (_class = (_UserMenuItem_brand = /*#__PURE__*/new WeakSet(), class UserMenuItem extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserMenuItem_brand);
  }
  get className() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).className;
  }
  get linkHref() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).linkHref;
  }
  get linkTitle() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).linkTitle;
  }
  get icon() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).icon;
  }
  get label() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).label;
  }
  get labelClass() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).labelClass;
  }
  get description() {
    const description = _classPrivateGetter(_UserMenuItem_brand, this, _get_item).description;
    if (description) {
      if (typeof description === "string") {
        // do emoji unescape on all items
        return htmlSafe(emojiUnescape(escapeExpression(description)));
      }
      // it's probably an htmlSafe object, don't try to unescape emojis
      return description;
    }
  }
  get descriptionClass() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).descriptionClass;
  }
  get topicId() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).topicId;
  }
  get iconComponent() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).iconComponent;
  }
  get iconComponentArgs() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).iconComponentArgs;
  }
  get endComponent() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).endComponent;
  }
  get endOutletArgs() {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).endOutletArgs;
  }
  onClick(event) {
    return _classPrivateGetter(_UserMenuItem_brand, this, _get_item).onClick({
      event,
      closeUserMenu: this.args.closeUserMenu
    });
  }
}), (_applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class);
function _get_item(_this) {
  return _this.args.item;
}
export { UserMenuItem as default };
setComponentTemplate(TEMPLATE, UserMenuItem);